import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import GridViewIcon from "@mui/icons-material/GridView";
import { CircularProgress, TextField, IconButton } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { CardProject } from "../components/dashboard/CardProject";
import { ListProject } from "../components/dashboard/ListProject";
import { DataUser } from "../context/DataUser";
import styles from "../css/ProjectsList.module.css";
import SearchIcon from '@mui/icons-material/Search';
import ContactlessIcon from '@mui/icons-material/Contactless';
import Modaladdcredits from "../components/dashboard/Modaladdcredits";
import DescriptionIcon from '@mui/icons-material/Description';
import Modaladdcreditsdescriptions from "../components/dashboard/Modaladdcreditsdescriptions";
import FolderDeleteIcon from '@mui/icons-material/FolderDelete';
import ModalDeleteSegments from "../components/dashboard/ModalDeleteSegments";

export const ProjectsList = ({ user, projects }) => {
  const [activeButton, setActiveButton] = useState("grid"); // Estado para rastrear el botón activo
  const { getProyects, pagination, rolFilter, page, setPage, stageFilter, loading, filter, setFilter, searchProjects, searchResults , useFilter, setUseFilter } = useContext(DataUser);
  const [projectsList, setProjectsList] = useState([]);
  const [openModaladdcredits, setOpenModaladdcredits] = useState(false);
  const [openModaladdcreditsdescriptions, setOpenModaladdcreditsdescriptions] = useState(false);
  const [openModalDeleteSegments, setOpenModalDeleteSegments] = useState(false);
  //console.log("projectsList",projectsList);
  const [loadingPage, setLoadingPage] = useState(false);
  const [filterText, setFilterText] = useState(""); // Applied filter, only updated when the search button is pressed
  const [searchInput, setSearchInput] = useState(""); // Live value of the search TextField
  const [showSearchField, setShowSearchField] = useState(false); // State to control TextField visibility
//console.log("useFilter",useFilter);
//console.log("filter",filter);

  const handleButtonClick = (button) => setActiveButton(button)

  const handleSearch = () => setFilterText(searchInput);

  useEffect(() => {setProjectsList(projects)}, [projects]);
  useEffect(() => {
    if (user?.roles.includes("PM") && filterText.length > 0) {
      setUseFilter(true);
      searchProjects(filterText, user.uid);
    } else {
      setUseFilter(false);
    }
  }, [filterText, user]);
  const sortByDateThenName = (a, b) => {
    const dateA = new Date(a.start_date).setHours(0, 0, 0, 0);
    const dateB = new Date(b.start_date).setHours(0, 0, 0, 0);
    const dateComparison = dateB - dateA;
    if (dateComparison !== 0) return dateComparison;
    return a.name.localeCompare(b.name); // Secondary sort by name
  };

  const displayedProjects = [
    ...(user?.roles.includes("PM") && filterText.length > 0
      ? searchResults // Si hay filtro y es PM, muestra resultados de búsqueda
      : projects), // Si no, muestra proyectos normales
  ].sort(sortByDateThenName);

console.log("searchProjects",searchProjects);

console.log("Displayed Projects:", displayedProjects); // Verifica qué datos se muestran
  const filteredProjects = Array.from(new Map(projectsList.map(project => [project._id, project])).values())
    .filter(project => project.name.toLowerCase().includes(filterText.toLowerCase()))
    .sort(sortByDateThenName);
  const loadProjects = async (page) => {
    setLoadingPage(true);
    if (user?.roles.includes("PM")) {
      if (rolFilter && page !== 1) {
        await getProyects(page, false, rolFilter)
      } else if (rolFilter && page === 1) {
        await getProyects(page, true, rolFilter)
      } else if (!rolFilter && page !== 1) {
        await getProyects(page, false)
      } else if (!rolFilter && page === 1) {
        await getProyects(page, true)
      }
    } else if (user?.roles.includes("QC")) {
      if (page !== 1 && !stageFilter) {
        await getProyects(page, false, "QC")
      } else if (page === 1 && !stageFilter) {
        await getProyects(page, true, "QC")
      } else if (page !== 1 && stageFilter === "Active") {
        await getProyects(page, false)
      } else if (page === 1 && stageFilter === "Active") {
        await getProyects(page, true)
      } else if (page !== 1 && stageFilter) {
        await getProyects(page, false, "QC", stageFilter)
      } else if (page === 1 && stageFilter) {
        await getProyects(page, true, "QC", stageFilter)
      }
    } else {
      if (page !== 1 && !stageFilter) {
        await getProyects(page, false, null)
      } else if (page === 1 && !stageFilter) {
        await getProyects(page, true, null)
      } else if (page !== 1 && stageFilter) {
        await getProyects(page, false, null, stageFilter)
      } else if (page === 1 && stageFilter) {
        await getProyects(page, true, null, stageFilter)
      }
    }
    setLoadingPage(false);
  };

  const handleContainerScroll = (e) => {
    const container = e.target;
    const tolerance = 1;
    if (
      container.scrollHeight - container.scrollTop <= container.clientHeight + tolerance && !loadingPage && !loading
    ) {
      if (pagination?.totalPages > 0 && pagination?.totalPages > page) {
        setPage(page + 1);
        loadProjects(page + 1);
      }
    }
  };

  return (
    <div className={styles.container}>
      <header className={styles.header__Projects}>
        <h2>
          <FolderOpenIcon /> {filter ? filter : "All Projects in Progress"}
        </h2>
        <div className={styles.filter__container}>
          {filter === "Narrator" && (
            <IconButton 
              aria-label="narrator" 
              sx={{ color: 'white' }} 
              onClick={() => setOpenModaladdcredits(true)}
              className="modal-trigger"
            >
              <ContactlessIcon />
            </IconButton>
          )}
            {filter === "Describer" && (
            <IconButton 
              aria-label="describer" 
              sx={{ color: 'white' }} 
              onClick={() => setOpenModaladdcreditsdescriptions(true)}
              className="modal-trigger"
            >
              <DescriptionIcon />
            </IconButton>
          )}
          {(!filter || filter === "All Projects in Progress") && (
            <IconButton 
              aria-label="Delete multiple segments for projects" 
              sx={{ color: 'white' }} 
              onClick={() => setOpenModalDeleteSegments(true)}
              className="modal-trigger"
            >
              <FolderDeleteIcon />
            </IconButton>
          )}
          <IconButton
            aria-label="toggle search"
            onClick={() => setShowSearchField(!showSearchField)}
            sx={{ color: 'white' }}
          >
            <SearchIcon />
          </IconButton>

          {showSearchField && (
            <>
              <TextField
                variant="outlined"
                placeholder="Filter projects..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") handleSearch(); }}
                className={styles.filterInput}
                InputProps={{
                  style: {height: '2rem', marginTop: '0.2rem', color: 'white'}
                }}
              />
              <IconButton aria-label="apply search" onClick={handleSearch} sx={{ color: 'white' }}>
                <SearchIcon />
              </IconButton>
            </>
          )}
        </div>
      </header>
      {activeButton === "grid" ? (
        <>
          {user?.roles && (
            <>
              <div className={styles.container__projectList} onScroll={handleContainerScroll}>
                {(projectsList?.length === 0 && !loading) && (
                  <div className={styles.container__noProjects}>
                    <h3>No projects</h3>
                  </div>
                )}
                {(!loading) && (
                  (user?.roles.includes("PM") ? displayedProjects : filteredProjects)
                    .map((project, index) => <CardProject key={index} project={project} />)
                )}
                {loading && <div className={styles.container_loading}><CircularProgress /></div>}
                <div aria-live="assertive" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', width: '100%' }}>
                  {(displayedProjects?.length > 0 && loadingPage) && (<CircularProgress aria-label='Loading projects...' aria-live="assertive" />)}
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <div className={styles.container__projectListTable}>
          <ListProject projects={user?.roles.includes("PM") ? displayedProjects : filteredProjects} user={user} />
        </div>
      )}
      <Modaladdcredits open={openModaladdcredits} setOpen={setOpenModaladdcredits} />
      <Modaladdcreditsdescriptions open={openModaladdcreditsdescriptions} setOpen={setOpenModaladdcreditsdescriptions} />
      <ModalDeleteSegments open={openModalDeleteSegments} setOpen={setOpenModalDeleteSegments} />
    </div>
  );
};
